// Image imports
import aiSupportAssistantImage from '../assets/images/ai-support-assistant.png'
import studentImage from '../assets/images/student.png'
import teacherImage from '../assets/images/teacher.png'
import digipalzLogo from '../assets/images/digipalz-logo.png'
import digipalzLogoBlack from '../assets/LandingPage/Digipalz_bl.png'
import educatorAccessImage from '../assets/images/educator-access.png'
import quizBulbImage from '../assets/images/quiz-bulb.png'
import supportMrAzabukiImage from '../assets/images/support-mr-azabuki.png'

//Mission Icons

import mission1 from '@/assets/icons/missionIcon/elementry_school.webp'
import mission2 from '@/assets/icons/missionIcon/computerLab.webp'
import mission3 from '@/assets/icons/missionIcon/cayman_airport.webp'
import mission4 from '@/assets/icons/missionIcon/police_station.webp'
import mission5 from '@/assets/icons/missionIcon/identity_theif.webp'
import mission6 from '@/assets/icons/missionIcon/online_scam.webp'
import mission7 from '@/assets/icons/missionIcon/malwar.webp'
import mission8 from '@/assets/icons/missionIcon/catfishing.webp'
import mission9 from '@/assets/icons/missionIcon/grooming.webp'
import mission10 from '@/assets/icons/missionIcon/social_engineering.webp'
import mission11 from '@/assets/icons/missionIcon/extortion.webp'
import mission12 from '@/assets/icons/missionIcon/ai.webp'

// Icon imports
import missionsIcon from '../assets/icons/missions.png'
import quizzesIcon from '../assets/icons/quizzes.png'
import studyGuideIcon from '../assets/icons/study-guide.png'
import supportChatIcon from '../assets/icons/support-chat.png'
import protectIcon from '../assets/icons/protect.png'
import profileIcon from '../assets/icons/profile.png'
import helpIcon from '../assets/icons/help.png'
import userStatusIcon from '../assets/icons/user-status.png'
import cyberbullyingIcon from '../assets/icons/cyberbullying.png'
import ipAndFootprintsIcon from '../assets/icons/ip-and-footprints.png'
import scamAndProtectionIcon from '../assets/icons/scam-and-protection.png'
import infoAndIdentityIcon from '../assets/icons/info-and-identity.png'
import aiAndDeepfakesIcon from '../assets/icons/ai-and-deepfakes.png'
import onlinePredatorsIcon from '../assets/icons/online-predators.png'
import extortionIcon from '../assets/icons/extortion.png'
import catFishingAndFakeProfilesIcon from '../assets/icons/cat-fishing-and-fake-profiles.png'
import groomingIcon from '../assets/icons/grooming.png'
import socialEngineeringIcon from '../assets/icons/social-engineering.png'
import assignmentsIcon from '../assets/icons/assignments.png'
import cyberbullyDefenseIcon from '../assets/icons/cyberbully-defense.png'
import passwordProtectorIcon from '../assets/icons/password-protector.png'
import privacyGuardianIcon from '../assets/icons/privacy-guardian.png'
import safeSocialMediaIcon from '../assets/icons/safe-social-media.png'
import aiAndDeepfakesDark from '../assets/icons/ai-and-deepfakes-dark.png'
import catFishingAndFakeProfilesDark from '../assets/icons/cat-fishing-and-fake-profiles-dark.png'
import groomingDark from '../assets/icons/grooming-dark.png'
import socialEngineeringDark from '../assets/icons/social-engineering-dark.png'
import extortionDark from '../assets/icons/extortion-dark.png'
import onlinePredatorsDark from '../assets/icons/online-predators-dark.png'
import ipAndFootprintsDark from '../assets/icons/ip-and-footprints-dark.png'
import scamAndProtectionDark from '../assets/icons/scam-and-protection-dark.png'
import infoAndIdentityDark from '../assets/icons/info-and-identity-dark.png'
import cyberbullyingDark from '../assets/icons/cyberbullying-dark.png'
import creditCardIcon from '../assets/icons/credit-card.png'
import downloadButtonIcon from '../assets/icons/download-button.png'
import sendIcon from '../assets/icons/send.png'
import micIcon from '../assets/icons/mic.png'
import attachIcon from '../assets/icons/attach.png'
import graduationHatIcon from '../assets/icons/graduation-hat.png'
import schoolIcon from '../assets/icons/school.png'
import shieldIcon from '../assets/icons/shield.png'
import graduationHatDark from '../assets/icons/graduation-hat-dark.png'
import informationIcon from '../assets/icons/information.png'

import FrameIcon from '../assets/icons/Frame.png'
import MessageIcon from '../assets/icons/message.png'

import keyIcon from '../assets/icons/keyIcon.png'

export const images = {
  studentImage,
  digipalzLogo,
  aiSupportAssistantImage,
  educatorAccessImage,
  teacherImage,
  quizBulbImage,
  supportMrAzabukiImage,
  digipalzLogoBlack
}

export const icons = {
  missionsIcon,
  quizzesIcon,
  studyGuideIcon,
  supportChatIcon,
  protectIcon,
  profileIcon,
  helpIcon,
  userStatusIcon,
  cyberbullyingIcon,
  ipAndFootprintsIcon,
  scamAndProtectionIcon,
  infoAndIdentityIcon,
  aiAndDeepfakesIcon,
  onlinePredatorsIcon,
  extortionIcon,
  catFishingAndFakeProfilesIcon,
  groomingIcon,
  socialEngineeringIcon,
  assignmentsIcon,
  cyberbullyDefenseIcon,
  passwordProtectorIcon,
  privacyGuardianIcon,
  safeSocialMediaIcon,
  aiAndDeepfakesDark,
  catFishingAndFakeProfilesDark,
  groomingDark,
  socialEngineeringDark,
  extortionDark,
  onlinePredatorsDark,
  ipAndFootprintsDark,
  scamAndProtectionDark,
  infoAndIdentityDark,
  cyberbullyingDark,
  creditCardIcon,
  downloadButtonIcon,
  sendIcon,
  micIcon,
  attachIcon,
  graduationHatIcon,
  schoolIcon,
  shieldIcon,
  graduationHatDark,
  informationIcon,

  FrameIcon,
  MessageIcon,

  //teacher_dashboard

  keyIcon
  //admin_dashboard
}

export const missionIcons = {
  mission1,
  mission2,
  mission3,
  mission4,
  mission5,
  mission6,
  mission7,
  mission8,
  mission9,
  mission10,
  mission11,
  mission12
}
